var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shop-login" }, [
    _c("div", { staticClass: "shop-login__body" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-wrapper v-center left spaced spacer--top" },
      [
        _vm._l(_vm.buttons, function (button) {
          return [
            _c("a", {
              staticClass: "button button--primary",
              attrs: { href: button.link },
              domProps: { innerHTML: _vm._s(button.label) },
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }